import { useEffect, useState, useMemo, useRef, useDeferredValue } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../../../../component/b2c/sidebar/sidebar';
import NavBar from '../../../../component/b2c/navBar/navBar';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import { useMyContext } from '../../../../context/MyContext';
import '../../../../css/custom-scrollbar.css';
import FullPageLoader from '../../../../component/fullPageLoader/fullPageLoader';
import { Base_Url, shipmentList, shipmentallList, deleteShipment, priceEstimator, shipmentlabel, bulkshipmentlabel, Url_For_View_Document, allwarehouseslist } from '../../../../config/config';
import ViewAllShipment from '../../../../component/b2c/models/ViewAllShipment';
import ViewRateForwardShipment from '../../../../component/b2c/models/ViewRateForwordShipmet';
import TrackingSidePopup from '../../../pages/dashborad/TrackingSidePopup';
import UploadBulk from '../../../../component/b2c/models/UploadBulk';
import axios from 'axios';
import { CgSearch } from "react-icons/cg";
import { FaList, FaHourglassHalf, FaClipboardList, FaTruck, FaDownload, FaShippingFast, FaTimesCircle, FaEllipsisV, FaFileDownload, FaInfoCircle, FaBox } from "react-icons/fa";
import { MdOutlinePendingActions } from "react-icons/md";
import { FaShopify } from "react-icons/fa";
import { SiWoocommerce } from "react-icons/si";
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import { RxCross2 } from "react-icons/rx";
import { FaEye } from "react-icons/fa";
import { FaTrash, FaCopy } from "react-icons/fa";
import { SiZoho } from "react-icons/si";
import { createPortal } from 'react-dom';
import { FaDotCircle } from "react-icons/fa";
import AddShipmentPopup from '../forword/forwordShipment'

// ⚡ Shipments cache (stale-while-revalidate): pehle cached data turant dikhao, phir background me fresh data lao
const SHIPMENT_CACHE_PREFIX = 'b2c_all_shipments_cache_';
const memoryShipmentCache = {};
const readShipmentCache = (cusId) => {
  const key = SHIPMENT_CACHE_PREFIX + (cusId || '');
  if (memoryShipmentCache[key]) return memoryShipmentCache[key];
  try {
    const raw = localStorage.getItem(key);
    const parsed = raw ? JSON.parse(raw) : null;
    if (Array.isArray(parsed)) { memoryShipmentCache[key] = parsed; return parsed; }
  } catch (e) { /* ignore corrupt cache */ }
  return null;
};
const writeShipmentCache = (cusId, data) => {
  const key = SHIPMENT_CACHE_PREFIX + (cusId || '');
  memoryShipmentCache[key] = data;
  try { localStorage.setItem(key, JSON.stringify(data)); } catch (e) { /* storage full - memory cache still works */ }
};

// ⚡ Ek hi waqt pe same API do baar na chale (fast remount / multiple refresh calls share one request)
const inFlightShipmentRequests = {};
const requestAllShipments = (token, cusId) => {
  const key = cusId || '';
  if (inFlightShipmentRequests[key]) return inFlightShipmentRequests[key];
  const p = fetch(`${Base_Url}${shipmentallList}`, {
    method: 'GET',
    headers: { token: token || '', cus_id: cusId || '', 'Content-Type': 'application/json' },
  })
    .then(res => res.json())
    .finally(() => { delete inFlightShipmentRequests[key]; });
  inFlightShipmentRequests[key] = p;
  return p;
};

// ⚡ Warehouse list memory cache (popups turant ready)
const memoryWarehouseCache = {};

// ⚡ Search index: har row ka lowercase text ek baar banta hai, har keystroke pe dobara nahi
const searchIndexCache = new WeakMap();
const getRowSearchText = (row) => {
  let text = searchIndexCache.get(row);
  if (text === undefined) {
    text = Object.values(row)
      .filter(value => value !== null && value !== undefined)
      .map(value => value.toString().toLowerCase())
      .join('\u0001');
    searchIndexCache.set(row, text);
  }
  return text;
};

const AllShipment = () => {
  const [allData, setAllData] = useState(() => readShipmentCache(localStorage.getItem('cus_id')) || []);
  const allDataRef = useRef(allData);
  allDataRef.current = allData;
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isloading, isSetLoading] = useState(false);
  const [isMobileCardView, setIsMobileCardView] = useState(false);

  const [activeTab, setActiveTab] = useState('all orders');
  const [searchTerm, setSearchTerm] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const limit = 15;

  const [selectedRowsForShip, setSelectedRowsForShip] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [selectedShipment, setSelectedShipment] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpenForShip, setIsPopupOpenForShip] = useState(false);

  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [actionMenuPos, setActionMenuPos] = useState({ top: 0, left: 0 });

  const [wareHouseList, setWareHouseList] = useState([]);

  // Add Shipment drawer
  const [isAddShipmentPopupOpen, setIsAddShipmentPopupOpen] = useState(false);

  // Upload Bulk popup
  const [uploadBulkPopupOpen, setUploadBulkPopupOpen] = useState(false);

  // Tracking side popup (opened from the info icon in Order ID & AWB column)
  const [isTrackingPopupOpen, setIsTrackingPopupOpen] = useState(false);
  const [trackingSearchTerm, setTrackingSearchTerm] = useState('');

  // Hover states for tooltips
  const [addressHover, setAddressHover] = useState({ id: null, x: 0, y: 0, above: false, data: null });
  const [statusHover, setStatusHover] = useState({ id: null, label: '', x: 0, y: 0, above: false });
  const [typeHover, setTypeHover] = useState({ id: null, label: '', x: 0, y: 0, above: false });
  const [customerHover, setCustomerHover] = useState({ id: null, x: 0, y: 0, above: false, data: null });
  const [productHover, setProductHover] = useState({ id: null, x: 0, y: 0, above: false, data: null });

  const { isDarkMode, isToggleSidebar, setorderId,setIsToggleSidebar } = useMyContext();
  const token = localStorage.getItem('token');
  const cusid = localStorage.getItem('cus_id');
  const role = localStorage.getItem('role');
  const navigateForTrack = useNavigate();

  useEffect(() => {
    const checkScreen = () => setIsMobileCardView(window.innerWidth < 768);
    checkScreen();
    window.addEventListener('resize', checkScreen);
    return () => window.removeEventListener('resize', checkScreen);
  }, []);

  useEffect(() => {
    fetchAllShipments();
    fetchWareHouseList();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (openActionMenu !== null && !e.target.closest('.action-dropdown-menu') && !e.target.closest('.action-dropdown-trigger')) {
        setOpenActionMenu(null);
      }
    };
    const handleScrollOrResize = () => setOpenActionMenu(null);
    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('scroll', handleScrollOrResize, true);
    window.addEventListener('resize', handleScrollOrResize);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('scroll', handleScrollOrResize, true);
      window.removeEventListener('resize', handleScrollOrResize);
    };
  }, [openActionMenu]);

  const fetchAllShipments = async () => {
    // Agar data pehle se dikh raha hai (cache) to full-page loader mat dikhao, chupchap refresh karo
    const showLoader = allDataRef.current.length === 0;
    try {
      if (showLoader) {
        setIsPageLoading(true);
        // Hybrid: Fetch 15 items first for instant display
        try {
          const initialResponse = await fetch(`${Base_Url}${shipmentList}?page=1&limit=15`, {
            method: 'GET',
            headers: { token: token || '', cus_id: cusid || '', 'Content-Type': 'application/json' },
          });
          const initialResult = await initialResponse.json();
          const initialData = initialResult?.data || [];
          if (initialData.length > 0) {
            setAllData(initialData);
            setIsPageLoading(false); // Hide loader early
          }
        } catch (e) {
          // fallback to alllist
        }
      }

      const result = await requestAllShipments(token, cusid);
      const freshData = result?.data || [];
      setAllData(freshData);
      writeShipmentCache(cusid, freshData);
    } catch (err) {
      toast.error("Failed to load shipments");
    } finally {
      setIsPageLoading(false);
    }
  };

  const fetchWareHouseList = async () => {
    if (memoryWarehouseCache[cusid || '']) setWareHouseList(memoryWarehouseCache[cusid || '']);
    try {
      const response = await fetch(Base_Url + allwarehouseslist, {
        method: 'GET',
        headers: { token: token || '', cus_id: cusid || '', 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      const transformedData = (data?.data || []).map(warehouse => ({
        value: warehouse.id,
        label: warehouse.name,
        pincode: warehouse.pincode
      }));
      setWareHouseList(transformedData);
      memoryWarehouseCache[cusid || ''] = transformedData;
    } catch (error) {
      console.error('Error fetching warehouse list:', error);
    }
  };

  const tabMatches = (item, tabKey) => {
    if (tabKey === 'all orders') return true;
    if (tabKey === 'Add Shipment list' || tabKey === 'pending') return item.status?.toLowerCase().includes('pending');
    if (tabKey === 'process order') return item.status?.toLowerCase().includes('pickup') || item.status?.toLowerCase().includes('scheduled');
    if (tabKey === 'manifest list') return item.status?.toLowerCase() === 'manifested';
    if (tabKey === 'delivered') return item.status?.toLowerCase().includes('delivered');
    if (tabKey === 'failed') return item.status?.toLowerCase().includes('failed') || item.status?.toLowerCase().includes('cancel');
    if (tabKey === 'out for pickup') return item.status?.toLowerCase() === 'out for pickup' || item.status?.toLowerCase() === 'pickup';
    if (tabKey === 'out for delivery') return item.status?.toLowerCase().includes('out for delivery') || item.status?.toLowerCase().includes('ofd');
    if (tabKey === 'shopify') return item.partner?.toLowerCase() === 'shopify';
    if (tabKey === 'woocommerce') return item.partner?.toLowerCase() === 'woocommerce';
    if (tabKey === 'zoho') return item.partner?.toLowerCase() === 'zoho';
    return false;
  };

  // ⚡ Tab counts sirf data change hone par ek baar calculate (har hover/render par nahi)
  const tabCounts = useMemo(() => {
    const keys = ['all orders', 'Add Shipment list', 'process order', 'out for pickup', 'out for delivery', 'manifest list', 'delivered', 'failed', 'shopify', 'woocommerce', 'zoho'];
    const counts = {};
    keys.forEach(k => { counts[k] = 0; });
    allData.forEach(item => { keys.forEach(k => { if (tabMatches(item, k)) counts[k] += 1; }); });
    return counts;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allData]);

  const getTabCount = (tabKey) => {
    if (tabCounts[tabKey] !== undefined) return tabCounts[tabKey];
    return allData.filter(item => tabMatches(item, tabKey)).length;
  };

  // ⚡ Input turant update hota hai, heavy filtering thoda baad (typing smooth rahegi)
  const deferredSearchTerm = useDeferredValue(searchTerm);

  const filteredData = useMemo(() => {
    let data = [...allData];
    switch (activeTab) {
      case 'Add Shipment list':
      case 'pending':
        data = data.filter(item => item.status?.toLowerCase().includes('pending')); break;
      case 'process order':
        data = data.filter(item => item.status?.toLowerCase().includes('pickup') || item.status?.toLowerCase().includes('scheduled')); break;
      case 'manifest list':
        data = data.filter(item => item.status?.toLowerCase() === 'manifested'); break;
      case 'delivered':
        data = data.filter(item => item.status?.toLowerCase().includes('delivered')); break;
      case 'failed':
        data = data.filter(item => item.status?.toLowerCase().includes('failed') || item.status?.toLowerCase().includes('cancel')); break;
      case 'out for pickup':
        data = data.filter(item => item.status?.toLowerCase() === 'out for pickup' || item.status?.toLowerCase() === 'pickup'); break;
      case 'out for delivery':
        data = data.filter(item => item.status?.toLowerCase().includes('out for delivery') || item.status?.toLowerCase().includes('ofd')); break;
      case 'shopify':
        data = data.filter(item => item.partner?.toLowerCase() === 'shopify'); break;
      case 'woocommerce':
        data = data.filter(item => item.partner?.toLowerCase() === 'woocommerce'); break;
      case 'zoho':
        data = data.filter(item => item.partner?.toLowerCase() === 'zoho'); break;
      default: break;
    }
    if (deferredSearchTerm.trim()) {
      const term = deferredSearchTerm.toLowerCase();
      data = data.filter(row => getRowSearchText(row).includes(term));
    }
    return data;
  }, [allData, activeTab, deferredSearchTerm]);

  const paginatedData = filteredData.slice((currentPage - 1) * limit, currentPage * limit);
  const totalPages = Math.ceil(filteredData.length / limit);

  useEffect(() => setCurrentPage(1), [activeTab, searchTerm]);

  const handleRowSelectForShip = (orderId, fullRow) => {
    if (selectedRowsForShip.includes(orderId)) {
      setSelectedRowsForShip(prev => prev.filter(id => id !== orderId));
      setSelectedRowsData(prev => prev.filter(row => row.order_id !== orderId));
    } else {
      setSelectedRowsForShip(prev => [...prev, orderId]);
      setSelectedRowsData(prev => [...prev, fullRow]);
    }
  };

  const handleSelectAllForShip = (checked) => {
    if (checked) {
      const pendingRows = paginatedData.filter(row => row.status?.toLowerCase().includes('pending'));
      setSelectedRowsForShip(pendingRows.map(row => row.order_id));
      setSelectedRowsData(pendingRows);
    } else {
      setSelectedRowsForShip([]);
      setSelectedRowsData([]);
    }
  };

  const handleRowSelectForLabel = (orderId) => {
    setSelectedRows(prev => prev.includes(orderId) ? prev.filter(id => id !== orderId) : [...prev, orderId]);
  };

  const handleSelectAllForLabel = (checked) => {
    if (checked) setSelectedRows(paginatedData.map(row => row.order_id));
    else setSelectedRows([]);
  };

  const handleBulkShipNow = async () => {
    if (selectedRowsData.length === 0) { toast.error("Please select at least one order to ship"); return; }
    const totals = selectedRowsData.reduce((acc, row) => ({
      length: acc.length + parseFloat(row.length || 0),
      width: acc.width + parseFloat(row.shipment_width || 0),
      height: acc.height + parseFloat(row.shipment_height || 0),
      weight: acc.weight + parseFloat(row.weight || 0),
      cod_amount: acc.cod_amount + parseFloat(row.cod_amount || 0)
    }), { length: 0, width: 0, height: 0, weight: 0, cod_amount: 0 });

    const pincodeCount = {};
    selectedRowsData.forEach(row => { const pin = row.pin; if (pin) pincodeCount[pin] = (pincodeCount[pin] || 0) + 1; });
    const mostCommonPincode = Object.keys(pincodeCount).reduce((a, b) => pincodeCount[a] > pincodeCount[b] ? a : b, '');

    const requestBody = {
      from_pincode: selectedRowsData[0].pickup_pin_code,
      to_pincode: mostCommonPincode,
      length: totals.length, width: totals.width, height: totals.height, weight: totals.weight,
      shipment_type: "Forward", declared_value: "",
      payment_mode: selectedRowsData[0].payment_mode,
      cod_amount: totals.cod_amount.toString()
    };

    setIsPageLoading(true);
    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: { 'Content-Type': 'application/json', token, cus_id: cusid },
      });
      if (response.data.status === "success") {
        const enrichedBulkShipment = { ...response.data, bulk_order: true, selected_orders: selectedRowsData.map(r => r.order_id), total_orders: selectedRowsData.length, bulk_totals: totals, most_common_pincode: mostCommonPincode, selectedRowsData };
        setSelectedShipment(enrichedBulkShipment);
        setIsPopupOpenForShip(true);
        setSelectedRowsForShip([]);
        setSelectedRowsData([]);
        fetchAllShipments();
      } else { toast.error(response.data.message || "Something went wrong"); }
    } catch (error) {
      toast.error(error?.response?.data?.messages?.error || error.message || "Something Went Wrong!");
    } finally { setIsPageLoading(false); }
  };

  const handleDownload = async () => {
    if (selectedRows.length === 0) return toast.error("No orders selected");
    isSetLoading(true); setIsPageLoading(true);
    try {
      const response = await fetch(Base_Url + bulkshipmentlabel, {
        method: 'POST',
        headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_ids: selectedRows }),
      });
      const data = await response.json();
      if (data.status === "SUCCESS" && data.DownloadLink) {
        window.open(Url_For_View_Document + data.DownloadLink, "_blank");
        toast.success("Bulk labels downloaded successfully!");
        fetchAllShipments();
      } else { toast.error(data.message || "Download failed"); }
    } catch (error) { toast.error("Download failed"); }
    finally { isSetLoading(false); setIsPageLoading(false); }
  };

  const handleViewClick = (row) => { setSelectedShipment(row); setIsPopupOpen(true); };
  const handleClick = (orderID) => { setorderId(orderID); navigateForTrack("/shipments/tracking"); };

  const handleCancelOrder = async (orderId) => {
    const confirmResult = await Swal.fire({
      title: 'Are you sure?', text: "Do you want to cancel this order?", icon: 'warning',
      showCancelButton: true, confirmButtonColor: '#d33', confirmButtonText: 'Yes, cancel it!',
    });
    if (!confirmResult.isConfirmed) return;
    setIsPageLoading(true);
    try {
      const response = await fetch(`${Base_Url}${deleteShipment}/${orderId}`, {
        method: 'GET', headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
      });
      if (response.ok) {
        toast.success("Order canceled successfully!");
        fetchAllShipments();
      }
    } catch (error) { toast.error(error.message); }
    finally { setIsPageLoading(false); }
  };

  const handlePrintLabel = async (orderId) => {
    setIsPageLoading(true);
    try {
      const response = await fetch(`${Base_Url}${shipmentlabel}`, {
        method: 'POST', headers: { token, cus_id: cusid, 'Content-Type': 'application/json' },
        body: JSON.stringify({ order_id: orderId }),
      });
      const data = await response.json();
      if (data.status === "SUCCESS" && data?.DownloadLink) {
        window.open(Base_Url + data.DownloadLink, '_blank');
        toast.success("Label downloaded successfully!");
        fetchAllShipments();
      }
    } catch (error) { toast.error('API error: ' + error.message); }
    finally { setIsPageLoading(false); }
  };

  const handleDownloadPOD = (row) => {
    if (!row?.epod_file) {
      toast.error("POD not available for this order yet");
      return;
    }
    window.open(Url_For_View_Document + row.epod_file, "_blank");
    toast.success("POD downloaded successfully!");
  };

  const copyToClipboard = (text, label) => { navigator.clipboard.writeText(text); toast.success(`${label} copied!`); };

  // Opens the side tracking popup for a specific order (info icon click)
  const handleOpenTrackingPopup = (orderId) => {
    setTrackingSearchTerm(orderId || '');
    setIsTrackingPopupOpen(true);
  };

  const getStatusStyle = (status) => {
    if (!status) return 'bg-gray-100 text-gray-600';
    const s = status.toLowerCase();
    if (s.includes('failed') || s.includes('cancel')) return 'bg-red-100 text-red-700';
    if (s.includes('pending')) return 'bg-yellow-100 text-yellow-700';
    return 'bg-emerald-100 text-emerald-700';
  };

  // Mobile status pill colors (glassy, gradient friendly)
  const getMobileStatusStyle = (status) => {
    if (!status) return 'bg-gray-500/15 text-gray-600 dark:text-gray-300 border-gray-400/30';
    const s = status.toLowerCase();
    if (s.includes('cancel')) return 'bg-red-500/15 text-red-600 dark:text-red-300 border-red-400/40';
    if (s.includes('failed')) return 'bg-black/80 text-white border-black/60 dark:bg-red-500/20 dark:text-red-300 dark:border-red-400/40';
    if (s.includes('pending')) return 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-400/40';
    if (s.includes('delivered')) return 'bg-emerald-500/15 text-emerald-700 dark:text-emerald-300 border-emerald-400/40';
    if (s.includes('out for delivery') || s.includes('ofd')) return 'bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-400/40';
    if (s.includes('out for pickup') || s === 'pickup') return 'bg-cyan-500/15 text-cyan-700 dark:text-cyan-300 border-cyan-400/40';
    if (s.includes('manifest')) return 'bg-purple-500/15 text-purple-700 dark:text-purple-300 border-purple-400/40';
    if (s.includes('transit')) return 'bg-indigo-500/15 text-indigo-700 dark:text-indigo-300 border-indigo-400/40';
    if (s.includes('process') || s.includes('scheduled')) return 'bg-orange-500/15 text-orange-700 dark:text-orange-300 border-orange-400/40';
    return 'bg-gray-500/15 text-gray-600 dark:text-gray-300 border-gray-400/30';
  };

  // Colorful badge classes per status (used for the desktop Status column)
  const getStatusBadgeColor = (status) => {
    if (!status) return 'border-gray-300 dark:border-indigo-400/40 bg-white dark:bg-indigo-500/10 text-gray-800 dark:text-indigo-200';
    const s = status.toLowerCase();

    if (s.includes('cancel')) return 'border-red-600 bg-red-600 text-white dark:border-red-400/60 dark:bg-red-500/20 dark:text-red-300';
    if (s.includes('failed')) return 'border-black bg-black text-white dark:border-red-400/60 dark:bg-red-500/20 dark:text-red-300';
    if (s.includes('pending')) return 'border-yellow-500 bg-yellow-100 text-yellow-800 dark:border-yellow-400/50 dark:bg-yellow-500/15 dark:text-yellow-300';
    if (s.includes('delivered')) return 'border-emerald-600 bg-emerald-100 text-emerald-800 dark:border-emerald-400/50 dark:bg-emerald-500/15 dark:text-emerald-300';
    if (s.includes('out for delivery') || s.includes('ofd')) return 'border-blue-600 bg-blue-100 text-blue-800 dark:border-blue-400/50 dark:bg-blue-500/15 dark:text-blue-300';
    if (s.includes('out for pickup') || s === 'pickup') return 'border-cyan-600 bg-cyan-100 text-cyan-800 dark:border-cyan-400/50 dark:bg-cyan-500/15 dark:text-cyan-300';
    if (s.includes('manifest')) return 'border-purple-600 bg-purple-100 text-purple-800 dark:border-purple-400/50 dark:bg-purple-500/15 dark:text-purple-300';
    if (s.includes('transit')) return 'border-indigo-600 bg-indigo-100 text-indigo-800 dark:border-indigo-400/50 dark:bg-indigo-500/15 dark:text-indigo-300';
    if (s.includes('process') || s.includes('scheduled')) return 'border-orange-500 bg-orange-100 text-orange-800 dark:border-orange-400/50 dark:bg-orange-500/15 dark:text-orange-300';

    return 'border-gray-300 dark:border-indigo-400/40 bg-white dark:bg-indigo-500/10 text-gray-800 dark:text-indigo-200';
  };

  // Deterministic colorful gradient for customer avatar (per customer, not all same/black)
  const avatarGradients = [
    'from-pink-500 to-rose-500',
    'from-orange-500 to-amber-500',
    'from-lime-500 to-green-500',
    'from-emerald-500 to-teal-500',
    'from-cyan-500 to-sky-500',
    'from-blue-500 to-indigo-500',
    'from-violet-500 to-purple-500',
    'from-fuchsia-500 to-pink-500',
    'from-red-500 to-orange-500',
    'from-teal-500 to-cyan-500',
    'from-indigo-500 to-blue-500',
    'from-purple-500 to-fuchsia-500',
  ];
  const getAvatarGradient = (seed) => {
    const str = (seed || 'U').toString();
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const index = Math.abs(hash) % avatarGradients.length;
    return avatarGradients[index];
  };

  const handleShipNow = async (data) => {
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const requestBody = {
      first_name: data.first_name,
      last_name: data.last_name,
      email: data.email,
      address: data.address,
      product_desc: data.products_desc,
      phone: data.phone,
      city: data.city,
      state: data.state,
      country: "India",
      payment_mode: data.payment_mode,
      total_amount: data.total_amount,
      address_type: "home",
      length: data.length,
      width: data.shipment_width,
      height: data.shipment_height,
      from_pincode: data.pickup_pin_code,
      to_pincode: data.pin,
      cod_amount: data.cod_amount,
      quantity: "1",
      weight: data.weight,
      shipment_type: "Forward",
      order_id: data.order_id
    };
    setIsPageLoading(true);
    try {
      const response = await axios.post(Base_Url + priceEstimator, requestBody, {
        headers: {
          'Content-Type': 'application/json',
          'token': token,
          'cus_id': cus_id,
        },
      });
      if (response.data.status === "success") {
        toast.success(response.data.message);
        const enrichedShipment = { ...response.data, order_id: data.order_id };
        handleViewClickForShip(enrichedShipment);
        fetchAllShipments();
      } else {
        toast.error(response.data.message || "Something went wrong. Please check the data.");
      }
    } catch (error) {
      const apiError = error?.response?.data?.messages?.error || error.message || "Something Went Wrong!";
      toast.error(apiError);
    } finally {
      setIsPageLoading(false);
    }
  };

  const handleViewClickForShip = (shipment) => {
    setSelectedShipment(shipment);
    setIsPopupOpenForShip(true);
  };

  const tabs = [
    { key: "all orders", label: "All Orders", icon: <FaList /> },
    { key: "Add Shipment list", label: "Pending", icon: <FaTruck /> },
    { key: "process order", label: "Process", icon: <FaClipboardList /> },
    { key: "out for pickup", label: "Out for Pickup", icon: <FaTruck /> },
    { key: "out for delivery", label: "Out for Delivery", icon: <FaTruck /> },
    { key: "manifest list", label: "Manifest", icon: <FaHourglassHalf /> },
    { key: "delivered", label: "Delivered", icon: <FaTruck /> },
    { key: "failed", label: "Failed", icon: <FaTimesCircle /> },
    { key: "shopify", label: "Shopify", icon: <FaShopify /> },
    { key: "woocommerce", label: "WooCommerce", icon: <SiWoocommerce /> },
    { key: "zoho", label: "Zoho", icon: <SiZoho /> },
  ];

  // Address hover handlers
  const handleAddressEnter = (e, row) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 200;
    setAddressHover({
      id: row.order_id,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above,
      data: row
    });
  };
const UploadBulkViewClick = () => setUploadBulkPopupOpen(true);
const handleCloseUploadBulk = () => setUploadBulkPopupOpen(false);
  const handleAddressLeave = () => {
    setAddressHover({ id: null, x: 0, y: 0, above: false, data: null });
  };

  // Status hover handlers
  const handleStatusEnter = (e, rowId, label) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 60;
    setStatusHover({
      id: rowId,
      label,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above
    });
  };

  const handleStatusLeave = () => setStatusHover({ id: null, label: '', x: 0, y: 0, above: false });

  // Type hover handlers
  const handleTypeEnter = (e, rowId, label) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 60;
    setTypeHover({
      id: rowId,
      label,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above
    });
  };

  const handleTypeLeave = () => setTypeHover({ id: null, label: '', x: 0, y: 0, above: false });

  // Customer Info hover handlers
  const handleCustomerEnter = (e, row) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 200;
    setCustomerHover({
      id: row.order_id,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above,
      data: row
    });
  };

  const handleCustomerLeave = () => {
    setCustomerHover({ id: null, x: 0, y: 0, above: false, data: null });
  };

  // Product Details hover handlers
  const handleProductEnter = (e, row) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.bottom;
    const above = spaceBelow < 200;
    setProductHover({
      id: row.order_id,
      x: rect.left + rect.width / 2,
      y: above ? rect.top + window.scrollY : rect.bottom + window.scrollY,
      above,
      data: row
    });
  };

  const handleProductLeave = () => {
    setProductHover({ id: null, x: 0, y: 0, above: false, data: null });
  };

  // Address Tooltip Portal
  const AddressTooltip = () => {
    if (!addressHover.id || !addressHover.data) return null;
    const row = addressHover.data;
    const pickupCity = row.pickup_city || '—';
    const pickupAddress = row.pickup_address || '';
    const destCity = row.city || '—';
    const destAddress = row.address || '';
    const pickupPhone = row.pickup_phone || '';
    const destPhone = row.delivery_phone || '';

    const style = {
      position: 'fixed',
      left: addressHover.x,
      top: addressHover.above ? 'auto' : addressHover.y - window.scrollY,
      bottom: addressHover.above ? window.innerHeight - (addressHover.y - window.scrollY) : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };

    return createPortal(
      <div style={style} className="flex flex-col items-center">
        {!addressHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mb-1"></div>}
        <div className="bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] text-gray-800 dark:text-white text-[9px] font-medium px-3 py-2 rounded-lg shadow-xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] border border-gray-200 dark:border-indigo-500/30 max-w-[280px] w-full">
          <div className="space-y-1.5">
            <div>
              <div className="flex items-center gap-1 text-[8px] text-gray-500 dark:text-indigo-300/70 uppercase tracking-wide">
                <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 inline-block"></span>
                Origin
              </div>
              <div className="font-semibold">{pickupCity}</div>
              <div className="text-gray-500 dark:text-indigo-200/70 text-[8px] break-words">{pickupAddress}</div>
              {pickupPhone && <div className="text-gray-500 dark:text-indigo-200/70 text-[8px]">📞 {pickupPhone}</div>}
            </div>
            <div className="border-t border-gray-200 dark:border-indigo-500/20 pt-1.5">
              <div className="flex items-center gap-1 text-[8px] text-gray-500 dark:text-indigo-300/70 uppercase tracking-wide">
                <span className="w-1.5 h-1.5 rounded-full bg-rose-500 inline-block"></span>
                Destination
              </div>
              <div className="font-semibold">{destCity}</div>
              <div className="text-gray-500 dark:text-indigo-200/70 text-[8px] break-words">{destAddress}</div>
              {destPhone && <div className="text-gray-500 dark:text-indigo-200/70 text-[8px]">📞 {destPhone}</div>}
            </div>
          </div>
        </div>
        {addressHover.above && <div className="w-2.5 h-2.5 bg-white dark:bg-[#0b0b14] border-r border-b border-gray-200 dark:border-indigo-500/30 rotate-45 -mt-1"></div>}
      </div>,
      document.body
    );
  };

  // Status Tooltip Portal
  const StatusTooltip = () => {
    if (!statusHover.id) return null;
    const style = {
      position: 'fixed',
      left: statusHover.x,
      top: statusHover.above ? 'auto' : statusHover.y - window.scrollY,
      bottom: statusHover.above ? window.innerHeight - (statusHover.y - window.scrollY) : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };
    return createPortal(
      <div style={style} className="flex flex-col items-center">
        {!statusHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mb-1"></div>}
        <div className="bg-gray-900 text-white text-[10px] font-medium px-3 py-1.5 rounded-lg shadow-xl whitespace-nowrap">{statusHover.label}</div>
        {statusHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mt-1"></div>}
      </div>,
      document.body
    );
  };

  // Type Tooltip Portal
  const TypeTooltip = () => {
    if (!typeHover.id) return null;
    const style = {
      position: 'fixed',
      left: typeHover.x,
      top: typeHover.above ? 'auto' : typeHover.y - window.scrollY,
      bottom: typeHover.above ? window.innerHeight - (typeHover.y - window.scrollY) : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };
    return createPortal(
      <div style={style} className="flex flex-col items-center">
        {!typeHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mb-1"></div>}
        <div className="bg-gray-900 text-white text-[10px] font-medium px-3 py-1.5 rounded-lg shadow-xl whitespace-nowrap">{typeHover.label}</div>
        {typeHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mt-1"></div>}
      </div>,
      document.body
    );
  };

  // Customer Info Tooltip Portal
  const CustomerTooltip = () => {
    if (!customerHover.id || !customerHover.data) return null;
    const row = customerHover.data;
    const fullName = `${row.first_name || ''} ${row.last_name || ''}`.trim() || '—';
    const phone = row.phone || '—';
    const email = row.email || '';
    const addressType = row.address_type || '';
    const partner = row.partner || '';

    const style = {
      position: 'fixed',
      left: customerHover.x,
      top: customerHover.above ? 'auto' : customerHover.y - window.scrollY,
      bottom: customerHover.above ? window.innerHeight - (customerHover.y - window.scrollY) : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };

    return createPortal(
      <div style={style} className="flex flex-col items-center">
        {!customerHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mb-1"></div>}
        <div className="bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] text-gray-800 dark:text-white text-[9px] font-medium px-3 py-2 rounded-lg shadow-xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] border border-gray-200 dark:border-indigo-500/30 max-w-[280px] w-full">
          <div className="space-y-1.5">
            <div>
              <div className="flex items-center gap-1 text-[8px] text-gray-500 dark:text-indigo-300/70 uppercase tracking-wide">
                <span className="w-1.5 h-1.5 rounded-full bg-indigo-500 inline-block"></span>
                Customer Info
              </div>
              <div className="font-semibold capitalize">{fullName}</div>
              {phone && <div className="text-gray-500 dark:text-indigo-200/70 text-[8px]">📞 {phone}</div>}
              {email && <div className="text-gray-500 dark:text-indigo-200/70 text-[8px] break-words">✉️ {email}</div>}
            </div>
            {(addressType || partner) && (
              <div className="border-t border-gray-200 dark:border-indigo-500/20 pt-1.5">
                {addressType && (
                  <div className="text-gray-500 dark:text-indigo-200/70 text-[8px]">Address Type: <span className="font-medium text-gray-700 dark:text-indigo-100 capitalize">{addressType}</span></div>
                )}
                {partner && (
                  <div className="text-gray-500 dark:text-indigo-200/70 text-[8px]">Source: <span className="font-medium text-gray-700 dark:text-indigo-100 capitalize">{partner}</span></div>
                )}
              </div>
            )}
          </div>
        </div>
        {customerHover.above && <div className="w-2.5 h-2.5 bg-white dark:bg-[#0b0b14] border-r border-b border-gray-200 dark:border-indigo-500/30 rotate-45 -mt-1"></div>}
      </div>,
      document.body
    );
  };

  // Product Details Tooltip Portal
  const ProductTooltip = () => {
    if (!productHover.id || !productHover.data) return null;
    const row = productHover.data;
    const productDesc = row.products_desc || '—';
    const quantity = row.quantity || '—';
    const weight = row.weight || '—';
    const dims = `${row.length || 0}×${row.shipment_width || 0}×${row.shipment_height || 0}`;
    const declaredValue = row.declared_value || row.total_amount || '';

    const style = {
      position: 'fixed',
      left: productHover.x,
      top: productHover.above ? 'auto' : productHover.y - window.scrollY,
      bottom: productHover.above ? window.innerHeight - (productHover.y - window.scrollY) : 'auto',
      zIndex: 999999,
      pointerEvents: 'none',
      transform: 'translateX(-50%)',
    };

    return createPortal(
      <div style={style} className="flex flex-col items-center">
        {!productHover.above && <div className="w-2.5 h-2.5 bg-gray-900 rotate-45 -mb-1"></div>}
        <div className="bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] text-gray-800 dark:text-white text-[9px] font-medium px-3 py-2 rounded-lg shadow-xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] border border-gray-200 dark:border-indigo-500/30 max-w-[280px] w-full">
          <div className="space-y-1.5">
            <div>
              <div className="flex items-center gap-1 text-[8px] text-gray-500 dark:text-indigo-300/70 uppercase tracking-wide">
                <span className="w-1.5 h-1.5 rounded-full bg-purple-500 inline-block"></span>
                Product Details
              </div>
              <div className="font-semibold break-words">{productDesc}</div>
            </div>
            <div className="border-t border-gray-200 dark:border-indigo-500/20 pt-1.5 space-y-0.5">
              <div className="text-gray-500 dark:text-indigo-200/70 text-[8px]">Quantity: <span className="font-medium text-gray-700 dark:text-indigo-100">{quantity}</span></div>
              <div className="text-gray-500 dark:text-indigo-200/70 text-[8px]">Weight: <span className="font-medium text-gray-700 dark:text-indigo-100">{weight}g</span></div>
              <div className="text-gray-500 dark:text-indigo-200/70 text-[8px]">Dimensions (L×W×H): <span className="font-medium text-gray-700 dark:text-indigo-100">{dims} cm</span></div>
              {declaredValue && <div className="text-gray-500 dark:text-indigo-200/70 text-[8px]">Value: <span className="font-medium text-gray-700 dark:text-indigo-100">₹{declaredValue}</span></div>}
            </div>
          </div>
        </div>
        {productHover.above && <div className="w-2.5 h-2.5 bg-white dark:bg-[#0b0b14] border-r border-b border-gray-200 dark:border-indigo-500/30 rotate-45 -mt-1"></div>}
      </div>,
      document.body
    );
  };

  const handleActionMenuToggle = (e, orderId) => {
    e.stopPropagation();
    if (openActionMenu === orderId) {
      setOpenActionMenu(null);
      return;
    }
    const rect = e.currentTarget.getBoundingClientRect();
    const menuWidth = 192;
    const gap = 6;

    let left = rect.right - menuWidth;
    if (left < 10) left = 10;
    if (left + menuWidth > window.innerWidth - 10) left = window.innerWidth - menuWidth - 10;

    const top = rect.bottom + gap;

    setActionMenuPos({ top, left });
    setOpenActionMenu(orderId);
  };
  const navigate = useNavigate();
  const glass =
    "backdrop-blur-2xl backdrop-saturate-150 bg-white/50 dark:bg-white/[0.06] " +
    "border border-white/60 dark:border-white/10 " +
    "shadow-[0_8px_32px_rgba(31,41,55,0.08)]";
  return (
    <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-gray-50'}`}>
      <div className="pointer-events-none absolute -top-32 -left-24 h-96 w-96 rounded-full bg-indigo-200/30 dark:bg-indigo-500/10 blur-3xl" />

      <NavBar />
      <div className="flex flex-1 overflow-hidden">
         {/* ── Mobile backdrop: tap outside to close the drawer (md and up: not shown) ── */}
                 {isToggleSidebar && (
                   <div
                     className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm md:hidden"
                     onClick={() => setIsToggleSidebar(false)}
                   />
                 )}
       
                 <div
                   className={`
                     fixed inset-y-0 left-0 z-50 w-64
                     ${isToggleSidebar ? "translate-x-0" : "-translate-x-full"}
                     md:static md:inset-auto md:z-auto md:translate-x-0
                     ${isToggleSidebar ? "md:w-64" : "md:w-[72px]"}
                     m-3
                     rounded-3xl
                 
                     overflow-hidden
                     transition-all
                     duration-300
                     ease-in-out
                   `}
                 >
                   <Sidebar />
                 </div>

        <FullPageLoader isLoading={isPageLoading} message="Processing..." />

        <div className="flex-1 p-2 md:p-2 overflow-y-auto bg-gray-100 dark:bg-black custom-scrollbar min-w-0">
          {/* ================= MOBILE HEADER (only < md) ================= */}
          <div className="md:hidden mb-3">
            <div className="flex items-center justify-between mb-3">
              <h1 className="text-lg font-bold text-gray-800 dark:text-white">
                All Shipments
              </h1>
              <span className="text-[10px] font-semibold text-indigo-600 dark:text-indigo-300 bg-indigo-50 dark:bg-indigo-500/15 px-2.5 py-1 rounded-full border border-indigo-100 dark:border-indigo-500/30">
                {filteredData.length} orders
              </span>
            </div>

            {/* Search bar full width */}
            <div className="relative w-full mb-3">
              <CgSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-indigo-300/70" size={18} />
              <input
                type="text"
                placeholder="Search Order ID, Name, Phone..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-11 pr-4 py-2.5 bg-white dark:bg-[#141425] border border-gray-200 dark:border-indigo-500/30 rounded-2xl focus:border-indigo-500 dark:focus:border-indigo-400 focus:ring-2 focus:ring-indigo-500/20 outline-none text-[13px] dark:text-white dark:placeholder-indigo-300/50 shadow-sm transition-all"
              />
            </div>

            {/* Two action buttons side by side */}
            <div className="flex gap-2">
              <button
                onClick={() => setIsAddShipmentPopupOpen(true)}
                className="flex-1 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-500 hover:to-purple-500 text-white px-4 py-2.5 rounded-2xl flex items-center justify-center gap-2 font-semibold text-[13px] shadow-lg shadow-indigo-500/25 active:scale-[0.97] transition-transform"
              >
                <FaShippingFast size={14} /> Add Shipment
              </button>
              <button
                onClick={UploadBulkViewClick}
                className="flex-1 bg-white dark:bg-[#141425] text-gray-700 dark:text-indigo-200 border border-gray-200 dark:border-indigo-500/30 hover:bg-gray-50 dark:hover:bg-indigo-500/10 px-4 py-2.5 rounded-2xl flex items-center justify-center gap-2 font-semibold text-[13px] shadow-sm active:scale-[0.97] transition-transform"
              >
                <FaBox size={14} /> Upload Bulk
              </button>
            </div>
          </div>

          {/* ================= DESKTOP HEADER (md and up) ================= */}
          <div className='hidden md:flex w-full justify-between items-center mb-3'>
            <h1 className="text-xl md:text-xl font-bold text-gray-800 dark:text-white">
              All Shipments
            </h1>
            <div className="flex gap-2 md:gap-3 items-start md:items-center">
              <button
                onClick={() => setIsAddShipmentPopupOpen(true)}
                className="bg-indigo-600 hover:bg-indigo-700 dark:bg-gradient-to-r dark:from-indigo-600 dark:to-purple-600 dark:hover:from-indigo-500 dark:hover:to-purple-500 dark:text-white dark:shadow-lg dark:shadow-indigo-900/50 text-white px-2 md:px-2 py-1.5 md:py-1.5 rounded-lg flex items-center gap-2 font-medium text-[12px] transition-all"
              >
                Add Shipment
              </button>

              <button
                onClick={UploadBulkViewClick}
                className="bg-gray-100 hover:bg-gray-200 text-gray-700 border border-gray-300 dark:bg-black dark:text-white dark:border-indigo-500/40 dark:hover:bg-indigo-500/10 px-2 md:px-2 py-1.5 md:py-1.5 rounded-lg flex items-center gap-2 font-medium text-[12px] transition-all"
              >
                <FaBox size={12} /> Upload Bulk
              </button>

              <div className="relative w-full md:w-80 lg:w-96 flex-shrink-0">
                <CgSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 dark:text-indigo-300/70" size={18} />
                <input
                  type="text"
                  placeholder="Search by Order ID, Name, Phone..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-1.5 md:py-1.5 bg-white dark:bg-[#1a1a2e] border border-gray-300 dark:border-indigo-400/50 rounded-xl focus:border-blue-500 dark:focus:border-indigo-400 dark:focus:ring-2 dark:focus:ring-indigo-500/40 outline-none text-sm dark:text-white dark:placeholder-indigo-300/50 transition-all"
                />
              </div>
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:items-end gap-3 md:gap-4 mb-2 md:mb-2">
            <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide flex-1">
              {tabs.map(tab => {
                const count = getTabCount(tab.key);
                const isActive = activeTab === tab.key;
                return (
                  <button
                    key={tab.key}
                    onClick={() => setActiveTab(tab.key)}
                    className={`flex items-center gap-1.5 px-3 md:px-2 py-2 md:py-1.5 text-[12px] md:text-[12px] font-medium rounded-xl transition-all whitespace-nowrap flex-shrink-0
                      ${isActive
                        ? "bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-lg"
                        : "bg-white dark:bg-black border border-gray-300 dark:border-indigo-500/30 hover:bg-gray-100 dark:hover:bg-indigo-500/10 dark:text-indigo-200"
                      }`}
                  >
                    <span className="hidden sm:inline">{tab.icon}</span>
                    <span>{tab.label}</span>
                    <span className={`ml-1 px-1.5 py-0.5 text-[8px] rounded-full ${isActive ? 'bg-white/30' : 'bg-gray-200 dark:bg-indigo-500/20 dark:text-indigo-200'}`}>
                      {count}
                    </span>
                  </button>
                );
              })}
            </div>
          </div>

          {((activeTab === 'Add Shipment list' || activeTab === 'pending') && selectedRowsForShip.length > 0) || selectedRows.length > 0 ? (
            <div className="mb-4 flex gap-2 md:gap-3 flex-wrap">
              {(activeTab === 'Add Shipment list' || activeTab === 'pending') && selectedRowsForShip.length > 0 && (
                <button
                  onClick={handleBulkShipNow}
                  className="bg-emerald-600 hover:bg-emerald-700 dark:bg-gradient-to-r dark:from-emerald-600 dark:to-teal-600 dark:hover:from-emerald-500 dark:hover:to-teal-500 dark:text-white dark:shadow-lg dark:shadow-emerald-900/40 text-white px-4 md:px-6 py-2 md:py-3 rounded-xl flex items-center gap-2 font-medium text-sm"
                >
                  <FaShippingFast /> Ship Now ({selectedRowsForShip.length})
                </button>
              )}
              {selectedRows.length > 0 && (
                <button
                  onClick={handleDownload}
                  disabled={isloading}
                  className="bg-purple-600 hover:bg-purple-700 dark:bg-gradient-to-r dark:from-indigo-600 dark:to-purple-600 dark:hover:from-indigo-500 dark:hover:to-purple-500 dark:text-white dark:shadow-lg dark:shadow-indigo-900/50 text-white px-4 md:px-6 py-2 md:py-3 rounded-xl flex items-center gap-2 font-medium text-sm disabled:opacity-70"
                >
                  {isloading ? "Processing..." : <><FaDownload /> Download Labels ({selectedRows.length})</>}
                </button>
              )}
            </div>
          ) : null}

          <style>{`
            @keyframes fadeSlideIn {
              from { opacity: 0; transform: translateY(10px); }
              to   { opacity: 1; transform: translateY(0); }
            }
            .row-animate { animation: fadeSlideIn 0.35s ease both; }
            tr.row-animate:hover td { background-color: rgba(99,102,241,0.04); transition: background 0.2s; }
            .scrollbar-hide::-webkit-scrollbar { display: none; }
            .scrollbar-hide { -ms-overflow-style: none; scrollbar-width: none; }
            @keyframes cardIn {
              from { opacity: 0; transform: translateY(12px) scale(0.98); }
              to   { opacity: 1; transform: translateY(0) scale(1); }
            }
            .card-animate { animation: cardIn 0.3s ease both; }
            .mobile-glass {
              background: linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7));
              backdrop-filter: blur(12px);
              -webkit-backdrop-filter: blur(12px);
            }
            .dark .mobile-glass {
              background: linear-gradient(135deg, rgba(15,15,25,0.9), rgba(20,20,35,0.8));
              backdrop-filter: blur(12px);
              -webkit-backdrop-filter: blur(12px);
            }
            .mobile-action-btn {
              transition: all 0.2s ease;
            }
            .mobile-action-btn:active {
              transform: scale(0.94);
            }
          `}</style>

          {isMobileCardView ? (
            <div className="flex flex-col gap-4 pb-4">
              {paginatedData.length === 0 && (
                <div className="text-center py-16 text-gray-400 dark:text-indigo-300/60 bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] rounded-3xl border border-gray-200 dark:border-indigo-500/25 shadow-lg">
                  <FaBox className="mx-auto mb-3 text-4xl opacity-30" />
                  <p className="font-medium">No orders found</p>
                </div>
              )}
              {paginatedData.map((row, index) => {
                const isPending = row.status?.toLowerCase().includes('pending');
                const isTrackingDisabled = row.status?.toLowerCase() === "pending" || row.status?.toLowerCase() === "failed" || !row.waybill;
                const isFailed = row.status?.toLowerCase() === "failed";
                const isChecked = selectedRowsForShip.includes(row.order_id) || selectedRows.includes(row.order_id);

                return (
                  <div
                    key={row.order_id}
                    className={`card-animate relative rounded-3xl overflow-hidden transition-all duration-300
                      ${isChecked
                        ? 'ring-2 ring-indigo-500/60 shadow-lg shadow-indigo-500/20'
                        : 'shadow-md shadow-black/5 dark:shadow-indigo-900/20'
                      }`}
                    style={{ animationDelay: `${index * 50}ms` }}
                  >
                    {/* Glass background */}
                    <div className={`absolute inset-0 ${
                      isChecked
                        ? 'bg-gradient-to-br from-indigo-50 via-white to-purple-50 dark:from-indigo-950/60 dark:via-[#0d0d18] dark:to-purple-950/40'
                        : 'bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14]'
                    }`} />
                    
                    {/* Top accent line */}
                    <div className={`absolute top-0 left-0 right-0 h-1 bg-gradient-to-r ${
                      isChecked ? 'from-indigo-500 via-purple-500 to-pink-500' : 'from-gray-200 via-gray-100 to-gray-200 dark:from-indigo-500/30 dark:via-purple-500/30 dark:to-pink-500/30'
                    }`} />

                    <div className="relative p-4">
                      {/* Header row */}
                      <div className="flex items-start justify-between mb-3">
                        <div className="flex items-center gap-3">
                          <div className="relative">
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => {
                                if (activeTab === 'Add Shipment list' || activeTab === 'pending') handleRowSelectForShip(row.order_id, row);
                                else handleRowSelectForLabel(row.order_id);
                              }}
                              className="w-5 h-5 rounded-md accent-indigo-600 dark:accent-indigo-400 cursor-pointer"
                            />
                          </div>
                          <div>
                            <div className="flex items-center gap-2">
                              <span
                                onClick={() => copyToClipboard(row.order_id, "Order ID")}
                                className="font-bold text-sm text-indigo-600 dark:text-indigo-300 cursor-pointer active:scale-95 transition-transform"
                              >
                                #{row.order_id}
                              </span>
                              {row.waybill && (
                                <button
                                  onClick={() => copyToClipboard(row.waybill, "AWB")}
                                  className="text-[10px] text-gray-400 dark:text-indigo-300/60 bg-gray-100 dark:bg-indigo-500/10 px-1.5 py-0.5 rounded-md active:scale-95 transition-transform"
                                >
                                  AWB: {row.waybill}
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                        <span className={`px-2.5 py-1 text-[10px] font-bold rounded-full border ${getMobileStatusStyle(row.status)}`}>
                          {row.status}
                        </span>
                      </div>

                      {/* Customer + avatar */}
                      <div className="flex items-center gap-3 mb-3 p-2.5 rounded-2xl bg-gray-50/80 dark:bg-white/[0.03]">
                        <div className={`w-10 h-10 rounded-full flex-shrink-0 bg-gradient-to-br ${getAvatarGradient(row.order_id || `${row.first_name}${row.last_name}`)} flex items-center justify-center shadow-lg shadow-black/10`}>
                          <span className="text-white text-sm font-bold">
                            {((row.first_name || row.last_name)?.charAt(0) || 'U').toUpperCase()}
                          </span>
                        </div>
                        <div className="min-w-0 flex-1">
                          <div className="font-semibold text-sm text-gray-800 dark:text-gray-100 capitalize truncate">
                            {row.first_name} {row.last_name}
                          </div>
                          <div className="text-[11px] text-gray-400 dark:text-indigo-300/60">
                            {row.phone}
                          </div>
                        </div>
                        <div className="text-right flex-shrink-0">
                          <div className="font-bold text-sm text-gray-800 dark:text-gray-100">₹{row.total_amount}</div>
                          {row.payment_mode === 'cod' && (
                            <div className="text-[10px] font-medium text-orange-500 dark:text-orange-400">COD ₹{row.cod_amount}</div>
                          )}
                        </div>
                      </div>

                      {/* Route */}
                      <div className="flex items-center gap-2 mb-3 px-1">
                        <div className="flex flex-col items-center pt-0.5">
                          <FaDotCircle className="text-emerald-500 dark:text-emerald-400" size={7} />
                          <span className="w-px flex-1 border-l border-dashed border-gray-300 dark:border-indigo-400/40 my-0.5" style={{ minHeight: '16px' }} />
                          <span className="w-2 h-2 bg-rose-500 dark:bg-rose-400 rounded-full flex-shrink-0" />
                        </div>
                        <div className="flex-1 flex flex-col gap-2">
                          <div className="flex items-center justify-between">
                            <span className="text-xs font-medium text-gray-700 dark:text-gray-200 truncate max-w-[140px]">
                              {row.pickup_city || '—'}
                            </span>
                            <span className="text-[10px] text-gray-400 dark:text-indigo-300/50">Origin</span>
                          </div>
                          <div className="flex items-center justify-between">
                            <span className="text-xs font-medium text-gray-700 dark:text-gray-200 truncate max-w-[140px]">
                              {row.city || '—'}
                            </span>
                            <span className="text-[10px] text-gray-400 dark:text-indigo-300/50">Destination</span>
                          </div>
                        </div>
                      </div>

                      {/* Product + meta */}
                      <div className="grid grid-cols-2 gap-2 mb-3">
                        <div className="p-2.5 rounded-2xl bg-gray-50/80 dark:bg-white/[0.03]">
                          <div className="text-[10px] text-gray-400 dark:text-indigo-300/50 uppercase tracking-wide mb-0.5">Product</div>
                          <div className="text-xs font-medium text-gray-700 dark:text-gray-200 line-clamp-1">
                            {row.products_desc || '—'}
                          </div>
                          <div className="text-[10px] text-gray-400 dark:text-indigo-300/50 mt-0.5">
                            Qty: {row.quantity} · {row.weight}g
                          </div>
                        </div>
                        <div className="p-2.5 rounded-2xl bg-gray-50/80 dark:bg-white/[0.03]">
                          <div className="text-[10px] text-gray-400 dark:text-indigo-300/50 uppercase tracking-wide mb-0.5">Date</div>
                          <div className="text-xs font-medium text-gray-700 dark:text-gray-200">
                            {new Date(row.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                          </div>
                          <div className="text-[10px] text-gray-400 dark:text-indigo-300/50 mt-0.5">
                            {row.length}×{row.shipment_width}×{row.shipment_height} cm
                          </div>
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="flex items-center gap-1.5 pt-2 border-t border-gray-100 dark:border-indigo-500/20">
                        <button
                          onClick={() => handleViewClick(row)}
                          className="mobile-action-btn flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-indigo-50 dark:bg-indigo-500/10 text-indigo-600 dark:text-indigo-300 text-xs font-semibold"
                        >
                          <FaEye size={13} /> View
                        </button>
                        {(activeTab === 'Add Shipment list' || activeTab === 'pending') && isPending && (
                          <button
                            onClick={() => handleShipNow(row)}
                            className="mobile-action-btn flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-emerald-50 dark:bg-emerald-500/10 text-emerald-600 dark:text-emerald-300 text-xs font-semibold"
                          >
                            <FaShippingFast size={13} /> Ship
                          </button>
                        )}
                        {(isPending || isFailed) && (
                          <button
                            onClick={() => handleCancelOrder(row.order_id)}
                            className="mobile-action-btn flex-1 flex items-center justify-center gap-1.5 py-2 rounded-xl bg-red-50 dark:bg-red-500/10 text-red-500 dark:text-red-400 text-xs font-semibold"
                          >
                            <RxCross2 size={13} /> Cancel
                          </button>
                        )}
                        {!isPending && (
                          <button
                            onClick={() => handlePrintLabel(row.order_id)}
                            className="mobile-action-btn flex items-center justify-center gap-1.5 px-3 py-2 rounded-xl bg-purple-50 dark:bg-purple-500/10 text-purple-600 dark:text-purple-300 text-xs font-semibold"
                          >
                            <FaDownload size={13} />
                          </button>
                        )}
                        <button
                          onClick={() => copyToClipboard(row.order_id, "Order ID")}
                          className="mobile-action-btn flex items-center justify-center p-2 rounded-xl bg-gray-50 dark:bg-white/[0.04] text-gray-400 dark:text-indigo-300/60"
                        >
                          <FaCopy size={13} />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            /* ================= DESKTOP TABLE — COMPACT NO SCROLL ================= */
            <div className="rounded-2xl overflow-x-auto" style={{ overflow: 'visible' }}>
              <table className="w-full table-auto border-separate border-spacing-x-0 border-spacing-y-1 text-xs">
                <thead>
                  <tr className="bg-gray-50 dark:bg-gradient-to-r dark:from-indigo-950 dark:via-purple-950 dark:to-indigo-950">
                    <th className="py-2 px-3 w-8 rounded-l-md border border-gray-200 dark:border-indigo-400/40 border-r-0 bg-gray-50 dark:bg-indigo-950/60">
                      <input
                        type="checkbox"
                        checked={
                          (activeTab === 'Add Shipment list' || activeTab === 'pending')
                            ? selectedRowsForShip.length === paginatedData.length
                            : selectedRows.length === paginatedData.length
                        }
                        onChange={(e) => {
                          if (activeTab === 'Add Shipment list' || activeTab === 'pending') handleSelectAllForShip(e.target.checked);
                          else handleSelectAllForLabel(e.target.checked);
                        }}
                        className="w-3 h-3 accent-black dark:accent-indigo-500"
                      />
                    </th>
                    <th className="py-2 px-3 text-left text-[12px] font-bold text-gray-500 dark:text-indigo-100 uppercase tracking-wider border-t border-b border-gray-200 dark:border-indigo-400/40 bg-gray-50 dark:bg-indigo-950/60 whitespace-nowrap">Order ID &amp; AWB</th>
                    <th className="py-2 px-3 text-left text-[12px] font-bold text-gray-500 dark:text-indigo-100 uppercase tracking-wider border-t border-b border-gray-200 dark:border-indigo-400/40 bg-gray-50 dark:bg-indigo-950/60 whitespace-nowrap">Customer Info</th>
                    <th className="py-2 px-3 text-left text-[12px] font-bold text-gray-500 dark:text-indigo-100 uppercase tracking-wider border-t border-b border-gray-200 dark:border-indigo-400/40 bg-gray-50 dark:bg-indigo-950/60 whitespace-nowrap">Origin &amp; Destination</th>
                    <th className="py-2 px-3 text-left text-[12px] font-bold text-gray-500 dark:text-indigo-100 uppercase tracking-wider border-t border-b border-gray-200 dark:border-indigo-400/40 bg-gray-50 dark:bg-indigo-950/60 whitespace-nowrap">Product Details</th>
                    <th className="py-2 px-3 text-right text-[12px] font-bold text-gray-500 dark:text-indigo-100 uppercase tracking-wider border-t border-b border-gray-200 dark:border-indigo-400/40 bg-gray-50 dark:bg-indigo-950/60 whitespace-nowrap">Payment</th>
                    <th className="py-2 px-3 text-center text-[12px] font-bold text-gray-500 dark:text-indigo-100 uppercase tracking-wider border-t border-b border-gray-200 dark:border-indigo-400/40 bg-gray-50 dark:bg-indigo-950/60 whitespace-nowrap">Status</th>
                    <th className="py-2 px-3 text-center text-[12px] font-bold text-gray-500 dark:text-indigo-100 uppercase tracking-wider border-t border-b border-gray-200 dark:border-indigo-400/40 bg-gray-50 dark:bg-indigo-950/60 whitespace-nowrap">Date</th>
                    <th className="py-2 px-3 text-center text-[12px] font-bold text-gray-500 dark:text-indigo-100 uppercase tracking-wider rounded-r-md border border-gray-200 dark:border-indigo-400/40 border-l-0 bg-gray-50 dark:bg-indigo-950/60 whitespace-nowrap">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {paginatedData.length === 0 && (
                    <tr>
                      <td colSpan={9} className="py-10 text-center text-gray-400 dark:text-indigo-300/60 text-[10px]">
                        No orders found
                      </td>
                    </tr>
                  )}
                  {paginatedData.map((row, index) => {
                    const isPending = row.status?.toLowerCase().includes('pending');
                    const isTrackingDisabled = row.status?.toLowerCase() === "pending" || row.status?.toLowerCase() === "failed" || !row.waybill;
                    const isFailed = row.status?.toLowerCase() === "failed";
                    const isChecked = selectedRowsForShip.includes(row.order_id) || selectedRows.includes(row.order_id);

                    const cellBg = isChecked
                      ? 'bg-indigo-50 dark:bg-indigo-500/10'
                      : 'bg-white dark:bg-[#0b0b14] group-hover:bg-gray-50 dark:group-hover:bg-indigo-500/5';
                    const cellBorder = 'border-gray-200 dark:border-indigo-400/30';

                    const fullStatus = row.status || '—';
                    const statusShortMap = {
                      'Cancelled': 'CN', 'Pending': 'PD', 'Out for Delivery': 'OFD',
                      'Delivered': 'DL', 'In Transit': 'IT', 'Manifested': 'MF',
                      'Failed': 'FL', 'Process': 'PR', 'Pickup': 'PK', 'Out for Pickup': 'OFP'
                    };
                    const shortStatus = statusShortMap[fullStatus] || fullStatus.replace(/_/g, " ").split(" ").map(w => w[0]).join("").slice(0, 3).toUpperCase();

                    return (
                      <tr
                        key={row.order_id}
                        className="group row-animate transition-all"
                        style={{ animationDelay: `${index * 40}ms` }}
                      >
                        <td className={`py-2 px-3 text-center ${cellBg} border-y border-l ${cellBorder} rounded-l-xl transition-colors`}>
                          <input
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => {
                              if (activeTab === 'Add Shipment list' || activeTab === 'pending') handleRowSelectForShip(row.order_id, row);
                              else handleRowSelectForLabel(row.order_id);
                            }}
                            className="w-3 h-3 accent-black dark:accent-indigo-500"
                          />
                        </td>

                        {/* Order ID & AWB */}
                        <td className={`py-2 px-3 align-center ${cellBg} border-y ${cellBorder} transition-colors`}>
                          <div className="flex flex-col">
                            <div className="flex items-center gap-1">
                              <span
                                onClick={() => copyToClipboard(row.order_id, "Order ID")}
                                className="font-semibold text-[12px] transition-colors select-none text-gray-600 dark:text-indigo-200 underline decoration-gray-300 dark:decoration-indigo-500/40 hover:decoration-black dark:hover:decoration-indigo-300 cursor-pointer"
                              >
                                {row.order_id}
                              </span>
                              <FaInfoCircle
                                className="cursor-pointer text-gray-400 dark:text-indigo-300/70 hover:text-black dark:hover:text-white transition-colors"
                                size={9}
                                onClick={() => handleOpenTrackingPopup(row.order_id)}
                              />
                            </div>
                            {row.waybill && (
                              <div onClick={() => copyToClipboard(row.waybill, "AWB")} className="text-[10px] text-gray-500 dark:text-indigo-300/60 cursor-pointer">
                                AWB: {row.waybill}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* Customer Info - with hover tooltip */}
                        <td
                          className={`py-2 px-3 text-[12px] align-center ${cellBg} border-y ${cellBorder} transition-colors cursor-pointer`}
                          onMouseEnter={(e) => handleCustomerEnter(e, row)}
                          onMouseLeave={handleCustomerLeave}
                        >
                          <div className="flex items-center gap-1.5">
                            <div className={`w-7 h-7 rounded-full flex-shrink-0 bg-gradient-to-br ${getAvatarGradient(row.order_id || `${row.first_name}${row.last_name}`)} flex items-center justify-center shadow-lg shadow-black/10`}>
                              <span className="text-white text-[12px] font-bold ">
                                {((row.first_name || row.last_name)?.charAt(0) || 'U').toUpperCase()}
                              </span>
                            </div>
                            <div className="min-w-0">
                              <div className="font-medium text-gray-800 dark:text-gray-100 capitalize truncate max-w-[90px]">{row.first_name} {row.last_name}</div>
                              <div className="text-gray-400 dark:text-indigo-300/60 text-[10px]">{row.phone}</div>
                            </div>
                          </div>
                        </td>

                        {/* Origin & Destination - with hover tooltip */}
                        <td
                          className={`py-2 px-3 text-[12px] align-center ${cellBg} border-y ${cellBorder} transition-colors cursor-pointer`}
                          onMouseEnter={(e) => handleAddressEnter(e, row)}
                          onMouseLeave={handleAddressLeave}
                        >
                          <div className="flex items-center gap-1.5">
                            <div className="flex flex-col items-center pt-1">
                              <FaDotCircle className="text-black dark:text-indigo-300" size={6} />
                              <span className="w-px flex-1 border-l border-dashed border-gray-300 dark:border-indigo-400/50 my-0.5" style={{ minHeight: '14px' }} />
                              <span className="w-1.5 h-1.5 bg-black dark:bg-indigo-400 rounded-full flex-shrink-0" />
                            </div>
                            <div className="space-y-1.5 min-w-0">
                              <div>
                                <div className="font-medium text-gray-600 dark:text-gray-200 leading-snug text-[12px] truncate max-w-[110px]">{row.pickup_city || '—'}</div>
                              </div>
                              <div>
                                <div className="font-medium text-gray-600 dark:text-gray-200 leading-snug text-[12px] truncate max-w-[110px]">{row.city || '—'}</div>
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* Product Details - with hover tooltip */}
                        <td
                          className={`py-2 px-3 align-center ${cellBg} border-y ${cellBorder} transition-colors cursor-pointer`}
                          onMouseEnter={(e) => handleProductEnter(e, row)}
                          onMouseLeave={handleProductLeave}
                        >
                          <div className="font-semibold text-gray-600 dark:text-gray-200 text-[12px] truncate max-w-[100px]">{row.products_desc || '—'}</div>
                          <div className="text-gray-400 dark:text-indigo-300/60 text-[9px]">Qty: {row.quantity} | {row.weight}g</div>
                          <div className="text-gray-400 dark:text-indigo-300/60 text-[9px]">{row.length}×{row.shipment_width}×{row.shipment_height}</div>
                        </td>

                        {/* Payment */}
                        <td className={`py-2 px-3 text-[12px] text-right align-center ${cellBg} border-y ${cellBorder} transition-colors`}>
                          <div className="font-semibold text-gray-600 dark:text-gray-100">₹{row.total_amount}</div>
                          {row.payment_mode === 'cod' && <div className="text-orange-500 text-[8px]">COD: ₹{row.cod_amount}</div>}
                        </td>

                        {/* Status - with hover tooltip */}
                        <td className={`py-2 px-3 text-center align-center ${cellBg} border-y ${cellBorder} transition-colors`}>
                          <span
                            className={`inline-flex px-2 py-0.5 text-[12px] font-semibold rounded-full border cursor-default ${getStatusBadgeColor(fullStatus)}`}
                            onMouseEnter={(e) => handleStatusEnter(e, row.order_id, fullStatus)}
                            onMouseLeave={handleStatusLeave}
                          >
                            {shortStatus}
                          </span>
                        </td>

                        {/* Date */}
                        <td className={`py-2 px-3 text-[12px] text-center align-center whitespace-nowrap ${cellBg} border-y ${cellBorder} transition-colors`}>
                          <div className="font-medium text-gray-600 dark:text-gray-200">
                            {new Date(row.created_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                          </div>
                        </td>

                        {/* Actions */}
                        <td className={`py-2 px-3 text-center align-center ${cellBg} border-y border-r ${cellBorder} rounded-r-xl transition-colors`}>
                          <button
                            onClick={(e) => handleActionMenuToggle(e, row.order_id)}
                            className="action-dropdown-trigger p-1 rounded-lg border border-gray-300 dark:border-indigo-400/40 hover:bg-gray-100 dark:hover:bg-indigo-500/15 transition-colors"
                          >
                            <FaEllipsisV size={11} className="text-gray-700 dark:text-indigo-300" />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            /* ================= END DESKTOP TABLE ================= */
          )}

          {totalPages > 1 && (
            <div className="flex justify-center mt-6 md:mt-8">
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={(e, v) => setCurrentPage(v)}
                variant="outlined"
                shape="rounded"
                size="small"
                className="pagination"
                renderItem={(item) => (
                  <PaginationItem
                    {...item}
                    className="mx-1 rounded-md"
                    style={{
                      color: isDarkMode ? '#c7d2fe' : '#000000',
                      borderColor: isDarkMode ? 'rgba(99,102,241,0.4)' : 'rgba(0,0,0,0.3)',
                      backgroundColor: item.selected
                        ? (isDarkMode ? 'rgb(79,70,229)' : '#1976d2')
                        : 'transparent',
                      ...(item.selected ? { color: '#ffffff' } : {}),
                    }}
                  />
                )}
              />
            </div>
          )}
        </div>
      </div>

      <AddressTooltip />
      <StatusTooltip />
      <TypeTooltip />
      <CustomerTooltip />
      <ProductTooltip />

      {openActionMenu !== null && (() => {
        const row = paginatedData.find(r => r.order_id === openActionMenu);
        if (!row) return null;
        const isPending = row.status?.toLowerCase().includes('pending');
        const isDelivered = row.status?.toLowerCase().includes('delivered');
        const isCancelled = row.status?.toLowerCase().includes('cancel');
        return (
          <div
            className="action-dropdown-menu fixed w-40 bg-white dark:bg-gradient-to-br dark:from-[#0b0b14] dark:via-[#0d0d18] dark:to-[#0b0b14] border border-gray-100 dark:border-indigo-500/30 rounded-2xl shadow-xl dark:shadow-[0_8px_40px_rgba(79,70,229,0.35)] ring-1 ring-black/5 dark:ring-indigo-500/20 z-[9999] py-1.5 text-left overflow-hidden"
            style={{ top: actionMenuPos.top, left: actionMenuPos.left }}
          >
            <button
              onClick={() => { handleViewClick(row); setOpenActionMenu(null); }}
              className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-indigo-600 dark:text-indigo-300 hover:bg-indigo-50 dark:hover:bg-indigo-500/15 transition-colors"
            >
              <FaEye size={14} /> View
            </button>

            {isPending ? (
              <>
                <button
                  onClick={() => { handleShipNow(row); setOpenActionMenu(null); }}
                  className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-emerald-600 dark:text-emerald-300 hover:bg-emerald-50 dark:hover:bg-emerald-500/15 transition-colors"
                >
                  <FaShippingFast size={14} /> Ship Now
                </button>
                <button
                  onClick={() => { handleCancelOrder(row.order_id); setOpenActionMenu(null); }}
                  className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-red-500 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-500/15 transition-colors"
                >
                  <RxCross2 size={14} /> Cancel
                </button>
              </>
            ) : (
              <>
                {!isCancelled && (
                  <button
                    onClick={() => { handlePrintLabel(row.order_id); setOpenActionMenu(null); }}
                    className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-purple-600 dark:text-purple-300 hover:bg-purple-50 dark:hover:bg-purple-500/15 transition-colors"
                  >
                    <FaDownload size={14} /> Print Label
                  </button>
                )}
                {isDelivered && (
                  <button
                    onClick={() => { handleDownloadPOD(row); setOpenActionMenu(null); }}
                    className="w-full flex items-center gap-2.5 px-4 py-2.5 text-sm text-blue-600 dark:text-blue-300 hover:bg-blue-50 dark:hover:bg-blue-500/15 transition-colors"
                  >
                    <FaFileDownload size={14} /> Download POD
                  </button>
                )}
              </>
            )}
          </div>
        );
      })()}

      <ViewAllShipment
        isopen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
        shipment={selectedShipment}
        wareHouseList={wareHouseList}
        fetchOrderData={fetchAllShipments}
      />
      <ViewRateForwardShipment isopen={isPopupOpenForShip} onClose={() => setIsPopupOpenForShip(false)} data={selectedShipment} />

      <TrackingSidePopup
        isOpen={isTrackingPopupOpen}
        onClose={() => setIsTrackingPopupOpen(false)}
        searchTerm={trackingSearchTerm}
        setSearchTerm={setTrackingSearchTerm}
        isDarkMode={isDarkMode}
      />

      <AddShipmentPopup
        isOpen={isAddShipmentPopupOpen}
        onClose={() => setIsAddShipmentPopupOpen(false)}
        onShipmentAdded={fetchAllShipments}
      />

      <UploadBulk isopen={uploadBulkPopupOpen} onClose={handleCloseUploadBulk} />
    </div>
  );
};

export default AllShipment;